import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  HashRouter,
} from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import VenderPaymentCreation from "../Invoice/VenderPaymentCreation";
import VenderPaymentRelease from "../PaymentProcess/VendorPaymentRelease";
//import BankStatement from "../Invoice/BankStatement";
import ProfilePage from "../Admin/ProfilePage";

import CreateNewUser from "../Admin/CreateNewUser";
import { getUserDetails } from "../../api/User";
import Redirect from "../Redirect";
//import ReceivableAndPayableStatement from "../Invoice/ReceivableAndPayableStatement";
//import MonthlyYearlyCashbook from "../Invoice/MonthlyYearlyCashbook";
import LedgerBook from "../Invoice/LedgerBook";
import VendorLedger from "../Invoice/VendorLedger";
// import DemandCollectionBalanceSheet from "../Invoice/DemandCollectionBalanceSheet";
// import InventoryStockMaterialRegister from "../Invoice/InventoryStockMaterialRegister";
// import ConsolidatedAbstractRegister from "../Invoice/ConsolidatedAbstractRegister";
// import MonthlyReconciliationStatement from "../Invoice/MonthlyReconciliationStatement";
// import WorkWiseMaterialRegister from "../Invoice/WorkWiseMaterialRegister";
// import InventoryStockOpening from "../Inventory Management/InventoryStockOpening";
// import InventoryStockInward from "../Inventory Management/InventoryStockInward";
// import InventoryStockOutward from "../Inventory Management/InventoryStockOutward";
// import InventoryStockManagement from "../Inventory Management/InventoryStockManagement";
import VendorRegistration from "../Admin/VendorRegistration";
import VendorApproval from "../Invoice/VendorApproval";
import PaymentExpenditure from "../Invoice/PaymentExpenditure";
// import AllTaxes from "../Invoice/AllTaxes";

// import CashWithdraw from "../Invoice/CashWithdraw";
// import VenderPaymentCreationReceivable from "../Invoice/VenderPaymentCreationReceivable";
import DigitalCertificateComponent from "../DSCValidation";
import UpdateVendorDetails from "../PaymentProcess/UpdateVendorDetails";
import DeductedTaxDetails from "../Invoice/DeductedTaxDetails";
import PaymentTrack from "../PaymentProcess/PaymentTrack";
import ErrorPage from "../ErrorPage/ErrorPage";


const AppRoutes = () => {
  const [userData, setUserData] = useState("");
  const [mainId, setMainId] = useState("");
  const [role, setRole] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [childData, setChildData] = useState(true);

  const [userDetail, setUserDetail] = useState(
    sessionStorage.getItem("userDetails")
      ? JSON.parse(sessionStorage.getItem("userDetails"))
      : null
  );
  const [token, setToken] = useState(
    sessionStorage.getItem("token")
      ? JSON.parse(sessionStorage.getItem("token"))
      : ""
  );
  // alert(sessionStorage.getItem("token"),sessionStorage.getItem("userDetails"))
  //   if(!sessionStorage.getItem("token") || !sessionStorage.getItem("userDetails")){
  //     window.location.href="http://localhost/govt-of-panchayat-sfc/"
      
  //   }

  const handleChildData = (data) => {
    setChildData(data);
  };

  //   const handleSession

  async function fetchRole(token, user) {
    setIsLoading(true);
    await getUserDetails(token, user)
      .then((res) => {
        setRole(res.data?.role_id);
        setMainId(res.data.user_id);
        setUserData(res);
      })
      .catch((err) => {
        console.log(err);
      });
    setIsLoading(false);
  }
 

  useEffect(() => {
    fetchRole(token, userDetail?.user_id);
  }, []);


  {
    let key = window.location.href.split("=")[0];
    console.log(key);
    
    //if(!sessionStorage.getItem("token") && !sessionStorage.getItem("userDetails")&& key!="http://localhost:3000/redirect?token"){
       if(!sessionStorage.getItem("token") && !sessionStorage.getItem("userDetails")&& key!="https://sfc-account.austere.biz/redirect?token"){
      // if(!sessionStorage.getItem("token") && !sessionStorage.getItem("userDetails")&& key!="https://accounts.fdms-sfc.com/redirect?token"){

      //window.location.href="http://localhost/govt-of-panchayat-sfc/"
       window.location.href="https://accounts.fdms-sfc.com/"
      // window.location.href="https://sfc-account.austere.biz/"


    }else{
      var PrivateRoutesData = [
        {
          path: "/redirect",
          component: Redirect,
          allowedRoles: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,38],
        },
        {
          path: "/vendor-payment-creation-payable",
          component: VenderPaymentCreation,
          allowedRoles: [6, 8, 10],
        },
        // {
        //   path: "/vendor-payment-creation-receivable",
        //   component: VenderPaymentCreationReceivable,
        //   allowedRoles: [6, 7],
        // },
        {
          path: "/vendor-payment-release",
          component: VenderPaymentRelease,
          allowedRoles: [7, 9, 11],
        },
        // {
        //   path: "/bank-statement",
        //   component: BankStatement,
        //   allowedRoles: [6, 7, 8, 9,38],
        // },
        {
          path: "/profile-page",
          component: ProfilePage,
          allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,38],
        },
        {
          path: "/create-new-user",
          component: CreateNewUser,
          allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        },
        // {
        //   path: "/demand-collection-balance-sheet",
        //   component: DemandCollectionBalanceSheet,
        //   allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,38],
        // },
        {
          path: "/vendor-ledger",
          component: VendorLedger,
          allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,38],
        },
        {
          path: "/ledger-book",
          component: LedgerBook,
          allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,38],
        },
        // {
        //   path: "/monthly-yearly-cashbook",
        //   component: MonthlyYearlyCashbook,
        //   allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,38],
        // },
        // {
        //   path: "/receivable-and-payable-statement",
        //   component: ReceivableAndPayableStatement,
        //   allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,30],
        // },
    
        // {
        //   path: "/inventory-stock-material-register",
        //   component: InventoryStockMaterialRegister,
        //   allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,38],
        // },
    
        // {
        //   path: "/consolidated-abstract-register",
        //   component: ConsolidatedAbstractRegister,
        //   allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,38],
        // },
        // {
        //   path: "/monthly-reconciliation-statement",
        //   component: MonthlyReconciliationStatement,
        //   allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,38],
        // },
        // {
        //   path: "/work-wise-material-register",
        //   component: WorkWiseMaterialRegister,
        //   allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,38],
        // },
        // {
        //   path: "/inventory-management",
        //   component: InventoryStockManagement,
        //   allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,38],
        // },
        // {
        //   path: "/cash-withdraw",
        //   component: CashWithdraw,
        //   allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,38],
        // },
        {
          path: "/vendor-registration",
          component: VendorRegistration,
          allowedRoles: [6, 8, 10],
        },
        {
          path: "/vendor-approval",
          component: VendorApproval,
          allowedRoles: [7,9,11],
        },
        {
          path: "/dsc-validation",
          component: DigitalCertificateComponent,
          allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,38],
        },
        {
          
          path: "/payment-expenditure",
          component: PaymentExpenditure,
          allowedRoles: [1, 2, 3, 4, 5, 6, 8, 10, 12, 38],
        },
        // {
          
        //   path: "/All-tax",
        //   component: AllTaxes,
        //   allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,38],
        // },
        {
          path: "/update-vendor",
          component: UpdateVendorDetails,
          allowedRoles: [1, 2, 3, 4, 5, 6, 8, 10, 12],
        },
        {
          path: "/deducted-tax",
          component: DeductedTaxDetails,
          allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,38],
        }
         ,
         {
          path: "/*",
          component: ErrorPage,
          allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,38],
        },
        {
          path: "/payment-track",
          component: PaymentTrack,
          allowedRoles: [1, 2, 3, 4, 5, 6, 8, 10, 12,38],
        }  
      ];
    }
  }

  return (
    <>
      <Router>
        <Routes>
          {PrivateRoutesData?.map((data) => (
            <Route
              key={data.path}
              path={data.path}
              element={
                <ProtectedRoute
                  component={data.component}
                  userData={userData}
                  userDetail={userDetail}
                  allowedRoles={data.allowedRoles}
                  onChildData={handleChildData}
                  mainId={mainId}
                  token={token}
                  role={userDetail?.role_id}
                />
              }
            />
          ))}
        </Routes>
      </Router>
    </>
  );
};

export default AppRoutes;
